import { MAP_VIEW } from '../../../constants/paths';
import { getBreakpoint } from '../../../hooks/useBreakpoint';
import { selectIsDiscord, selectIsMobile } from '../../../selectors/app';
import { selectIsDesktopNowPlayingEnabled } from '../../../selectors/config';
import { isSmall } from '../../../utils/breakpoints';
import isDesktop from '../../../utils/desktop/isDesktop';

export default function shouldOpenNowPlayingDialog(state) {
  const { dialog } = state;
  const isDesktopNowPlayingEnabled = selectIsDesktopNowPlayingEnabled(state);
  const isDiscord = selectIsDiscord(state);
  const isMapView = window.location.pathname === MAP_VIEW;

  const showOnMobile = selectIsMobile(state) && !isSmall(getBreakpoint()) && !isDiscord;
  const showOnDesktop = isDesktop() && isDesktopNowPlayingEnabled && !isMapView;
  const showOnDiscord = isDiscord && !isMapView;

  return (showOnDesktop || showOnMobile || showOnDiscord) && !dialog.isNowPlayingDialogOpen;
}
